import React, { createContext, useContext, useState } from 'react';

import { AlertColor, Snackbar } from '@mui/material';

import { Alert } from '~/components/Alert';
import { NOOP } from '~/NOOP';

interface INotificationContext {
  type: AlertColor;
  message: string;
}

const NotificationContext = createContext<React.Dispatch<React.SetStateAction<INotificationContext | undefined>>>(NOOP);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = (props) => {
  const [notification, notify] = useState<INotificationContext>();

  const handleClose = () => notify(undefined);

  return (
    <NotificationContext.Provider value={notify}>
      {props.children}
      {notification && (
        <Snackbar open autoHideDuration={6000} onClose={handleClose}>
          <div>
            <Alert
              severity={notification.type}
              message={notification.message}
              onClose={handleClose}
            />
          </div>
        </Snackbar>
      )}
    </NotificationContext.Provider>
  );
}

export const useNotification = () => useContext(NotificationContext);
